import type { CoachingSession } from '@efdigital/ll-addon-data';
import { queryCoachingSessionsByCoachingPlan } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-sessions';
import {
  COACHEE_ACTION_REQUIRED_QUERY_KEYS,
  COACHEE_PENDING_CONFIRMATION_KEYS,
  filterCoacheeActionRequired,
} from '@efdigital/ll-xceed-v2/utils/coaching/session-current-categories';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortModel } from '../cohort';

export type CoachingCoacheeCohortSessionsModel = CoachingCoacheeCohortModel & {
  pendingConfirmation: CoachingSession[];
  actionRequired: CoachingSession[];
  actionRequiredCount: number;
};

export default class CoachingCoacheeCohortSessionsRoute extends Route<CoachingCoacheeCohortSessionsModel> {
  @service declare store: Store;

  async model(): Promise<CoachingCoacheeCohortSessionsModel> {
    const cohortModel = this.modelFor(
      'coaching.coachee.cohort'
    ) as CoachingCoacheeCohortModel;
    const coachingPlanId = cohortModel.coachingPlan!.id!;

    const [pendingSessions, actionRequiredQuery] = await Promise.all([
      this.store.request(
        queryCoachingSessionsByCoachingPlan(
          coachingPlanId,
          COACHEE_PENDING_CONFIRMATION_KEYS
        )
      ),
      this.store.request(
        queryCoachingSessionsByCoachingPlan(
          coachingPlanId,
          COACHEE_ACTION_REQUIRED_QUERY_KEYS
        )
      ),
    ]);

    const pendingConfirmation = pendingSessions.content.data;
    const actionRequired = filterCoacheeActionRequired(
      actionRequiredQuery.content.data
    );

    return {
      ...cohortModel,
      pendingConfirmation,
      actionRequired,
      actionRequiredCount: actionRequired.length,
    };
  }
}
